export default class Stablast{
    /**
     * 
     * @param {*} list 
     * @param {*} p1 
     * @param {*} p2 
     * @param {*} Orientierung 
     * @param {*} Bezugslänge 
     * @param {*} Stabliste 
     * @param {*} Lastfall 
     */
    constructor(list, p1, p2, Orientierung, Bezugslänge, Stabliste, Lastfall){
        this.Werte = [p1, p2]
        this.Orientierung = Orientierung //0=global; 1=lobal
        this.Bezugslänge = Bezugslänge // 0=Stablänge; 1=Projektion auf Z
        this.Lastfall = Lastfall || undefined
        this.Stabliste = Stabliste ? [...Stabliste] : []
        this.list = list || null
        this.d3Node = undefined
    }
    get number() {
        if(this.list) return this.list.indexOf(this)+1
        else return null
    }

    get name() { return 'Stablast Nr. ' + this.number }

    set p1(v) { this.Werte[0] = v }
    set p2(v) { this.Werte[1] = v }
    get p1() { return this.Werte[0] }
    get p2() { return this.Werte[1] }

    globalWerte(curStab) {
        let p = [0,0,0,0]
        let dx = curStab.vector.x
        let dy = curStab.vector.y
        let tcos = curStab.tcos
        // Global auf Stablänge; Fall für Eigenlasten
        if (this.Orientierung == 0 && this.Bezugslänge == 0){
            p[2]=this.Werte[0]/tcos; p[3]=this.Werte[1]/tcos
            //p0 und p1 = 0 (keine Anteile in X-Richtung)
        } 
        // Global auf Projektion; Fall für Schneelasten
        else if(this.Orientierung == 0 && this.Bezugslänge == 1){
            p[2]=this.Werte[0]; p[3]=this.Werte[1]
            //p0 und p1 = 0 (keine Anteile in X-Richtung)             
        }
        // Lokal auf Stablänge; Fall für Windlasten
        else if(this.Orientierung == 1 && this.Bezugslänge == 0){
            p[0] = Math.sign(dy)*this.Werte[0]
            p[1] = Math.sign(dy)*this.Werte[1]
            p[2] = Math.sign(dx)*this.Werte[0]
            p[3] = Math.sign(dx)*this.Werte[1]

        }  
        return p
    }
       
    ersKnotenlast(curStab, elementfreiheitsgrad) {
        let Wert = 0
        let dx = curStab.vector.x
        let dy = curStab.vector.y  
        const p = this.globalWerte(curStab)      

            switch (elementfreiheitsgrad){
                case 0: //QP1
                    Wert += Math.abs(dy)*(7*p[0]+3*p[1])/20
                break
                case 1: //QP2
                    Wert += Math.abs(dx)*(7*p[2]+3*p[3])/20
                break
                case 2: //QP3
                    Wert += (dx*dx * (p[2] / 2 + p[3] / 3)*Math.sign(dx) + dy*dy*(p[0] /2 + p[1] /3)* Math.sign(dy)) / 10
                break
                case 3: //QP4    
                    Wert += Math.abs(dy)*(3*p[0]+7*p[1])/20
                break
                case 4: //QP5
                    Wert += Math.abs(dx)*(3*p[2]+7*p[3])/20
                break
                case 5: //QP6
                    Wert += (-dx*dx * (p[2] / 3 + p[3] / 2)*Math.sign(dx) - dy*dy*(p[0] /3 + p[1] /2)* Math.sign(dy)) / 10
                break
            }
        return Wert
    }

    release_bindings(){ 
        this.Stabliste.splice(0, this.Stabliste.length)
        return this.Lastfall.deleteStablast(this)
    }

    add_Stabverknüpfung(stab){this.Stabliste.push(stab)}

    delete_Stabverknüpfung(stab){
        if (this.Stabliste.indexOf(stab)==-1) return console.log('Stab nicht in Liste')
        this.Stabliste.splice(this.Stabliste.indexOf(stab),1)
        if (this.Stabliste.length == 0) return this.Lastfall.deleteStablast(this)
    }
    
}